import { FC, memo, SyntheticEvent } from 'react';
import { Transition } from 'react-transition-group';
import ButtonChevron from '@bridebook/ui/src/components/bbcommon/buttons/button-chevron/button-chevron';
import componentStyles from './lightweight-carousel-prev-next-buttons.style';

interface CarouselPrevNextButtonsProps {
  show: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export const LightweightCarouselPrevNextButtons: FC<CarouselPrevNextButtonsProps> =
  // eslint-disable-next-line react/display-name
  memo(({ onPrev, onNext, show }) => {
    const styles = componentStyles();
    const handlePrev = (event: SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onPrev();
    };

    const handleNext = (event: SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onNext();
    };

    return (
      <Transition in={show} timeout={0}>
        {(transitionState) => (
          <div style={{ ...styles.transitionStyle, ...styles.transitionStyles[transitionState] }}>
            <ButtonChevron
              style={styles.buttonLeft}
              rounded
              w={38}
              h={38}
              iconWidth={13}
              onClick={handlePrev}
              disabled={false}
              direction="left"
            />
            <ButtonChevron
              style={styles.buttonRight}
              rounded
              w={38}
              h={38}
              iconWidth={13}
              onClick={handleNext}
              disabled={false}
              direction="right"
            />
          </div>
        )}
      </Transition>
    );
  });
